<template>
<div v-if='com_show != 0' id='Confirm'>

	<div :class="{'com-mask':true, 'com-mask-show':com_show===2}">
		<div :class="{'com-model':true, 'com-model-show':com_show===2}">
			<div class='com-model-content'>
				<img class='com-model-con-icon' src='@/assets/icon/msg-information.png' />
				<div class='com-model-con-font font-16'>{{content}}</div>
			</div>
			<div class='com-model-btn font-14 no-copy'>
				<div v-if='no' class='com-model-btn-view com-model-btn-view-cancel' @click='noChange'>{{no}}</div>
				<div class='com-model-btn-view com-model-btn-view-affirm' @click='yesChange'>{{yes}}</div>
				<div v-if='linkcaption !== ""' class='com-model-btn-view com-model-btn-view-affirm' @click='fun_redirect(linkaddress)'>{{linkcaption}}</div>
			</div>
		</div>
	</div>

</div>
</template>
<script>
import iconInformation from '@/assets/icon/msg-information.png';
import iconSuccess from '@/assets/icon/msg-success.png';
import iconFail from '@/assets/icon/msg-fail.png';
import iconWarning from '@/assets/icon/msg-warning.png';

export default {
	name: 'Confirm',
	props: {},
	data() {
		return {
			com_show: 0,
			statusMap: {
				information: iconInformation,
				success: iconSuccess,
				fail: iconFail,
				warning: iconWarning,
			},
			content: '',
			no: '',
			yes: '',
			linkcaption: '',
			linkaddress: '',
		}
	},
	methods: {
		//打开弹窗
		vCon_Change(status, content, affirm, cancel, btn,caption,address) {
			if (this.com_show !== 0) return;

			if (status.constructor['name'] === 'String') this.status=this.statusMap[status];
			if (content.constructor['name'] === 'String') this.content=content;
			if (affirm.constructor['name'] === 'Function') this.affirm=affirm;
			if (cancel.constructor['name'] === 'Function') this.cancel=cancel;
			if (btn.constructor['name'] === 'Object' && btn['yes']) {
				this.yes = btn['yes'];
				this.no = btn['no'];
			}
			if (caption !== undefined) {
				this.linkcaption = caption;
			}
			if (address !== undefined) {
				this.linkaddress = address;
			}
			this.com_show = 1;
			setTimeout(() => {
				this.com_show = 2;
			}, 20)
		},
		//关闭弹窗
		vCon_Close() {
			this.com_show = 1;
			setTimeout(() => {
				this.content = '';
				this.no = '';
				this.yes = '';
				this.affirm = this.func_comnull;
				this.cancel = this.func_comnull;
				this.com_show = 0;
			}, 300)
		},
		//规定按钮事件
		noChange() {
			this.vCon_Close();
			this.cancel();
		},
		yesChange() {
			this.vCon_Close();
			this.affirm();
		},
		fun_redirect() {
			this.vCon_Close();
				this.$router.push({
						name: this.linkaddress,
					});
					
		},
		//参数按钮事件
		affirm() {},
		cancel() {},
		func_comnull() {},
	},
	mounted() {
		/* var mo = function(e) {
			e.preventDefault();
		};
		document.body.style.overflow = 'hidden'; */
		// document.addEventListener('touchmove', mo, false);
	}
}
</script>
<style scoped>
#Confirm {
}
.com-mask {
	background:rgba(55, 55, 55, 0);
	width:100%; height:100vh;
	position:fixed; top:0; left:0;
	z-index:400;
	transition: all 0.3s ease-in-out 0s;
}
.com-mask-show {
	background:rgba(55, 55, 55, .6);
}
.com-model {
	background:#ffffff;
	width:360px; /* height:182px; */ margin:120px auto 0 auto;
	box-sizing:border-box; padding:20px 20px 16px 20px;
	border-radius:6px;
	box-shadow:0 2px 8px rgba(0, 0, 0, .15);
	opacity:0;
	transform: scale(1.285);
	transition: all 0.3s ease-in-out 0s;
}
.com-model-show {
	opacity:1;
	transform: scale(1);
}
.com-model-content {
	width:100%; margin-bottom:20px;
	display:flex; justify-content:space-between;
}
.com-model-con-icon {
	width:36px; height:36px;
}
.com-model-con-font {
	width:calc(100% - 50px); min-height:30px; color:#17233d; letter-spacing:.6px;
	display:inline-flex; align-items:center;
}
.com-model-btn {
	width:100%; height:36px;
	display:flex; justify-content:flex-end; align-items:center;
}
.com-model-btn-view {
	height:32px; margin-left:8px;
	display:inline-flex; align-items:center;
	box-sizing:border-box; padding:0 16px;
	border-radius:4px;
	cursor:pointer;
}
.com-model-btn-view-cancel {
	color:#515a6e;
	transition: all 0.2s ease-in-out 0s;
}
.com-model-btn-view-cancel:hover {
	/* background:rgba(255, 104, 1, .1); */
}
.com-model-btn-view-affirm {
	background:rgba(255, 104, 1, .9);
	color:#ffffff;
	transition: all 0.2s ease-in-out 0s;
}
.com-model-btn-view-affirm:hover {
	background:rgba(255, 104, 1, .7);
}
</style>




// WEBPACK FOOTER //
// src/components/popup/Confirm.vue